export enum FeatureFlags {
    LibraryFeaturedCourseId = 'learnFeaturedCourseId',
    IsQualtricsBiotypeSurveyDisabled = 'hideQualtricsBiotypeSurvey',
    IsWatchMeThriveTabEnabled = 'isWatchMeThriveTabEnabled',
    IsNewCompanyResourceEnabled = 'isNewCompanyResourceCardEnabled',
    IsConfirmationDialogEnabled = 'IsConfirmationDialogEnabled'
}
